import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#8A1B8F",
        secondary: "#E70AA2",
        accent: "#C414A0",
        error: "#b71c1c",
      },
    },
  },
});
